import { API_URL } from './constants'
import { getCompanyId, queryString, responseHandler, errorResponseHandler } from './apiHelpers'

import axios from 'axios'

const instance = axios.create({
  withCredentials: true,
  baseURL: API_URL,
  headers: {
    companyId: getCompanyId(),
  },
})

instance.interceptors.response.use(
  res => responseHandler(res),
  err => errorResponseHandler(err),
)

export const get = (path, params, headers = {}) =>
  instance.get(`${API_URL}${path}${params ? queryString(params) : ''}`, {
    headers: {
      ...headers,
      companyId: getCompanyId(),
    },
  })

export const post = (path, request, params, headers = {}) =>
  instance.post(`${API_URL}${path}/${params ? params : ''}`, request, {
    headers: {
      ...headers,
      companyId: getCompanyId(),
    },
  })

export const apiDelete = (path, data, headers = {}) =>
  instance.delete(`${API_URL}${path}`, {
    headers: {
      ...headers,
      companyId: getCompanyId(),
    },
  })

export const fileDownload = async (path, params, headers = {}) => {
  const { signal, ...queryParams } = params || {}
  const response = await instance.get(`${API_URL}${path}/${params ? queryString(queryParams) : ''}`, {
    responseType: 'blob',
    signal,
    headers: {
      ...headers,
      companyId: getCompanyId(),
    },
  })
  // when there is an error, the response is a blob that needs to be converted back to json
  const contentType = response?.headers?.['content-type']
  if (response?.status >= 400 && contentType && contentType?.includes('application/json')) {
    const text = await response.data.text()
    const json = JSON.parse(text)
    throw json
  }

  return response
}
